<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <view-component v-if="attributes" :attributes="attributes"></view-component>
    <loader :isLoading="isLoading"  class="loading-overlay"></loader>
    <div v-if="this.hideFreezer">
      <v-row class="border-style shelves"
        v-for="(shelf, shelfIndex) in freezerData.shelves"
        :key="shelfIndex"
      >
        <v-col cols="12">
          <v-card>
            <v-card-title class="d-flex align-center justify-space-between"
              @click="toggleShelf(shelfIndex)"
            >
              <div class="shelf-title">
                Shelf No. {{ shelf.shelfNo || shelfIndex + 1 }}
              </div>

              <v-icon>
                {{ openShelves.includes(shelfIndex) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-expand-transition>
                <v-row v-if="openShelves.includes(shelfIndex)">
                  <!-- <div
                    :style="{zIndex: currentShelf !== shelfIndex? 1 : -1 }"
                  >
                    <p class="display-shelf-label"> Shelf No. {{ shelfIndex + 1 }}</p>
                  </div> -->
                  <!-- put it here -->
                  <v-col
                    v-for="(column, colIndex) in shelf.contents"
                    :key="column._id || colIndex"
                    cols="12"
                    :md="getColumnSize(shelf)"
                  >
                    <v-card
                      class="column-card"
                      :class="`column-${column.type?.toLowerCase()}`"
                      @click="viewColumn(column, shelf)"
                    >

                      <!-- HEADER -->
                      <div class="column-header">
                        <v-icon small class="mr-1">
                          {{ getColumnIcon(column.type) }}
                        </v-icon>
                        <span>Column {{ column.columnNo }}</span>

                        <v-spacer></v-spacer>

                        <v-icon small class="action-icon" @click.stop="viewColumn(column)">
                          mdi-information-outline
                        </v-icon>
                      </div>

                      <!-- BODY -->
                      <div class="column-body">

                        <!-- EMPTY -->
                        <div v-if="column.type === 'Empty'" class="empty-state">
                          <v-icon size="40">mdi-close-circle-outline</v-icon>
                          <div>Empty</div>
                        </div>

                        <!-- BOX -->
                        <div v-else-if="column.type === 'Box'"
                          class="box-state"
                          @click.stop="openBox(column, shelf)"
                        >
                          <div class="box-state clickable">
                            <v-icon size="40">mdi-package-variant-closed</v-icon>
                            <div class="mt-2 font-weight-bold">
                              {{ column.name || 'Box Storage' }}
                            </div>

                            <div class="text-caption mt-1">
                              Click to manage boxes
                            </div>
                          </div>
                        </div>

                        <!-- RACK -->
                        <div v-else-if="column.type === 'Rack'" class="rack-physical">

                          <!-- HEADER stays on top -->
                          <div class="rack-header">
                            <v-icon size="36">mdi-view-stream</v-icon>

                            <div class="font-weight-bold ml-2">
                              {{ column.name || 'Rack' }}
                            </div>
                          </div>

                          <!-- FULL HEIGHT SLIDING RACK BODY -->
                          <div class="rack-body">
                            <div
                              v-for="i in Number(column.slidingRacksNo)"
                              :key="i"
                              class="rack-drawer"
                              @click.stop="openSlidingRack(column, shelf, i)"
                            >

                              <div class="drawer-left">
                                {{ i }}
                              </div>

                              <div class="drawer-center">
                                Sliding Rack {{ i }}
                              </div>

                              <div class="drawer-right">
                                <v-icon small>mdi-chevron-right</v-icon>
                              </div>

                            </div>
                          </div>

                        </div>
                      <!-- OTHERS -->
                      <div v-else-if="column.type === 'Others'" class="others-state">
                        <div class="others-wrapper">
                          <v-icon size="40">mdi-dots-horizontal-circle-outline</v-icon>

                          <div class="mt-2 font-weight-bold">
                            {{ column.name || 'Others' }}
                          </div>

                          <div class="text-caption mt-1">
                            {{ column.notes || 'No additional configuration' }}
                          </div>
                        </div>
                      </div>
                        <!-- OTHER -->
                        <div v-else class="other-state">
                          <v-icon>mdi-dots-horizontal-circle-outline</v-icon>
                          <div>Unassigned</div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expand-transition>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!-- SLIDING RACK and BOX-ONLY VIEW -->
    <div class="sliding-rack-body" v-if="showSlidingRack || showBoxView">
      <!-- This is the box UI -->
      <!-- the box is being populated whenever there is a stored box by addBox() -->
      <v-row>
        <v-col cols="12">
          <v-btn class="return-btn" block @click="returnToShelf()">
            <v-icon
              class="mr-2"
              color="blue"
            >
                mdi-arrow-left-circle-outline
            </v-icon>
            Return
          </v-btn>
          <v-breadcrumbs v-if="activeLocation.activeRackNo" :items="[
            { text: `Shelf No. ${activeLocation.activeShelfNo}` },
            { text: `Rack No. ${activeLocation.activeRackNo}` },
            { text: `Sliding Rack No. ${activeLocation.activeSlidingRackNo}`}
          ]">
            <template v-slot:divider>
              <v-icon>mdi-forward</v-icon>
            </template>
            <template v-slot:item="{ item }">
              <span>{{ item.text }}</span>
            </template>
          </v-breadcrumbs>
          <v-breadcrumbs v-else :items="[
            { text: `Shelf No. ${activeBoxContext.shelf.shelfNo}` },
            { text: `Column No. ${activeBoxContext.column.columnNo}` },
          ]">
            <template v-slot:divider>
              <v-icon>mdi-forward</v-icon>
            </template>
            <template v-slot:item="{ item }">
              <span>{{ item.text }}</span>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row v-if="renderBoxes.length">
        <v-col cols="12" class="d-flex justify-center align-center freezer-indicator">
          <label>BACK SIDE</label>
        </v-col>
      </v-row>
      <!-- Redered Box -->
      <v-row cols="12" v-for="(renderBox) in renderBoxes"
        :key="renderBox.id + '-' + (renderBox.selectedId || '')"
      >
        <div style="display: contents">
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <div class="box-label">{{renderBox.name}}</div>
              </v-card-title>
              <v-card-text>
                <table class="box-table" v-if="renderBox">
                  <tr>
                    <th class="box-location"
                      v-for="col in validNumber(renderBox.noOfColumn)+1"
                      :key="col"
                    >
                      <div v-if="col-1 !== 0">
                        {{ boxLocationInitial[col-2] }}
                      </div>
                    </th>
                  </tr>
                  <tr class="box-row" v-for="(row, vertical) in validNumber(renderBox.noOfRows)"
                    :key="vertical"
                  >
                    <th class="box-location" v-if="vertical+1 !== 0">{{ vertical+1 }}</th>
                    <td class="box-column" v-for="col in validNumber(renderBox.noOfColumn)"
                      :key="col">
                      <div v-for="(specimen) in specimens" :key="specimen.code">
                            <div
                              v-if="(boxLocationInitial[col - 1] + row
                              === specimen.location.boxLocation) &&
                              activeLocation.activeShelfNo.toString()
                              === specimen.location.shelfNumber.toString()
                              && activeLocation.activeRackNo.toString()
                              === specimen.location.rackNumber.toString()
                              && activeLocation.activeSlidingRackNo.toString()
                              === specimen.location.slidingRackNumber.toString()
                              && specimen.location.boxNumber === renderBox.id
                              "
                              class="truncate-text"
                            >
                              <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn @click="onEdit(specimen)"
                                    block color="primary"
                                    v-bind="attrs" v-on="on"
                                  >
                                    <b>{{ specimen.code }}</b>
                                  </v-btn>
                                </template>
                                  <strong>Code:</strong> {{ specimen.code }}<br>
                                  <strong>Case Number:</strong>
                                    {{
                                      specimen.caseNumber?specimen.caseNumber._id.caseNumber:'N/A'
                                    }}<br>
                                  <strong>Specimen Source:</strong>
                                    {{
                                      specimen.specimenSource? specimen.specimenSource: 'N/A'
                                    }}<br>
                                  <strong>Type:</strong> {{ specimen.specimenType.name }}<br>
                                  <strong>State:</strong> {{ specimen.specimenState.name }}<br>
                                  <strong>Collecting Institution:</strong>
                                    {{
                                      specimen.siteOfCollection?specimen.siteOfCollection.name:'N/A'
                                    }}<br>
                                  <div v-if="specimen.siteOfCollection">
                                    <strong>Province:</strong> {{ specimen.province }}<br>
                                    <strong>Region:</strong> {{ specimen.region }}<br>
                                  </div>
                                  <strong>Note:</strong>
                                    {{
                                      specimen.note?specimen.note:'N/A'
                                    }}<br>
                                  <strong>Box Location:</strong>
                                    {{
                                      specimen.location.boxLocation
                                    }}
                              </v-tooltip>
                            </div>
                         </div>
                    </td>
                  </tr>
                </table>
              </v-card-text>
              <v-card-actions>
              <v-btn
                text
                color="primary"
                @click="removeBox(renderBox)"
              >
                Remove
              </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </div>
      </v-row>
      <v-row v-if="renderBoxes.length">
        <v-col cols="12" class="d-flex justify-center align-center freezer-indicator">
          <label>FRONT SIDE</label>
        </v-col>
      </v-row>
      <v-card class="mt-5">
        <v-card-title>
          Add Box
        </v-card-title>
        <v-card-text>
          <v-select
            ref="select"
            v-model="selectedBox"
            :items="boxOptions"
            item-text="name"
            item-value="_id"
            label="Select a Box"
            return-object
            single-line
            filled
            clearable
            @update:modelValue="setBoxData"
            dense
            hide-no-data
            filter
            :key="boxWithLocation.join(',')"
          >
            <template v-slot:item="{ item }">
              <v-list-item
                :key="item._id"
                :disabled="boxWithLocation.some((bwl) => bwl === item._id)"
                @click="handleSelect(item)"
              >
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="confirmBox(selectedBox)">Add</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <!-- BOX VIEW -->

    <!-- COLUMN DETAILS DIALOG -->
    <v-dialog
      v-model="columnDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">
            mdi-information-outline
          </v-icon>

          Column Details
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pt-4">

          <div class="mb-4">
            <div class="dialog-label">
              Name
            </div>

            <div class="dialog-value">
              {{ selectedColumn.name || 'N/A' }}
            </div>
          </div>

          <div>
            <div class="dialog-label">
              Notes
            </div>

            <div class="dialog-value">
              {{ selectedColumn.notes || 'No notes available' }}
            </div>
          </div>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="columnDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import Loader from '../../../components/utilities/Loader.vue';
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ViewComponent from '../../../components/ViewComponent.vue';

import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;

const { biobankRegistry } = services;
// caseSpecimenService
const { freezerService, boxService, caseSpecimenService } = biobankRegistry;

export default {
  components: {
    Loader,
    LandingCreate,
    ViewComponent,
  },
  data: () => ({
    storeBoxes: [],
    boxLocationInitial: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], // to be updated
    hideFreezer: true,
    showSlidingRack: false,
    isLoading: false,
    attributes: null,
    activeLocation: {
      activeShelfNo: '',
      activeRackNo: '',
      activeSlidingRackNo: '',
    },
    content: {
      pageTitle: 'Freezer View',
      enableBackButton: true,
    },
    freezerData: {},
    storeArray: [],
    selectedBox: {},
    boxOptions: [],
    specimens: [],
    mainBoxes: [],
    singleBox: {},
    renderBoxes: [],
    // currentShelf: null, for edit reference
    openShelves: [],
    currentRack: null,
    showBoxView: false,
    activeBoxContext: {
      shelf: null,
      column: null,
    },
    columnDialog: false,
    selectedColumn: {},
    // isOpenRack: true,
  }),
  async created() {
    this.isLoading = true;
    const { id } = this.$route.params;
    // make this get all
    const freezer = await freezerService.getOne({ id });
    this.freezerData = freezer;
    this.attributes = this.prepareAttribute(freezer);
    this.storeBoxes = this.freezerData.boxNumbers;
    this.isLoading = false;
    // check all
    const freezerList = await freezerService.getList();
    freezerList.forEach((fl) => {
      fl.boxNumbers.forEach((bn) => {
        if (bn?.boxId) {
          this.boxWithLocation.push(bn.boxId);
        }
      });
    });
    this.specimens = await caseSpecimenService.getList();
    // list of boxes
    this.boxOptions = (await boxService.getList())
      .map((document) => document);

    this.fetchAllBoxes();
  },
  computed: {
    boxWithLocation() {
      return this.freezerData.boxNumbers.map((box) => box.boxId);
    },
  },
  methods: {
    prepareAttribute({ _metadata, name, temperature }) {
      return [
        {
          label: 'Freezer Name',
          value: name,
        },
        {
          label: 'Temperature',
          value: temperature,
        },
        {
          label: 'Created by',
          value: { id: _metadata.created.user._id, name: _metadata.created.user.fullName },
          reference: true,
          URLName: 'user.view',
        },
        {
          label: 'Created date',
          value: _metadata.created.date,
          type: 'datetime',
        },
        {
          label: 'Updated by',
          value: { id: _metadata.updated.user._id, name: _metadata.updated.user.fullName },
          reference: true,
          URLName: 'user.view',
        },
        {
          label: 'Updated date',
          value: _metadata.updated.date,
          type: 'datetime',
        },
      ];
    },
    openSlidingRack(column, shelf, index) {
      this.activeLocation = {
        activeShelfNo: shelf.shelfNo,
        activeRackNo: column.columnNo,
        activeSlidingRackNo: index,
      };

      this.activeBoxContext = {};

      this.hideFreezer = false;
      this.showSlidingRack = true;

      this.filterBoxes();
    },
    async addBox() {
      const setBoxLocation = {
        boxLocation: {
          shelfNo: this.activeLocation.activeShelfNo,
          rackNo: this.activeLocation.activeRackNo,
          slidingRackNo: this.activeLocation.activeSlidingRackNo,
        },
      };
      // setBoxLocation.boxNumber = this.selectedBox;
      this.storeBoxes.push(setBoxLocation);
      this.singleBox = setBoxLocation;
    },
    validNumber(value) {
      // Convert to a number, if invalid, return a default (e.g., 1 or 0)
      const parsedValue = parseInt(value, 10);
      return Number.isNaN(parsedValue) ? 0 : parsedValue; // Default to 0 if invalid
    },
    async saveBox() {
      this.$confirmDialog.show({
        title: 'Confirm',
        text: 'Are you sure you want to <b>Add</b> this box?',
      }, async () => {
        if (Object.keys(this.singleBox).length > 0) {
          this.isLoading = true;
          this.freezerData.id = this.freezerData._id;
          this.freezerData.boxNumbers = this.mainBoxes;
          try {
            await freezerService.update({ freezer: this.freezerData });
            this.$snackbar.showOk({ text: 'Successfully Added!' });
            this.$router.go(0);
            // the input should not let the same box to create
            // const renderThis = await this.fetchBoxData(this.singleBox.boxId);
            // // this.boxWithLocation.push(this.singleBox.boxId);
            // this.renderBoxes.push({ ...renderThis });
            // this.singleBox = {};
          } catch (e) {
            this.isLoading = false; // only reset if it fails
            const error = e.response.data;
            this.$snackbar.showBad({
              text: ErrorMessageUtil.transform(error),
            });
          }
        } else {
          this.$snackbar.showBad({ text: 'Please Select a Box' });
        }
        this.isLoading = false;
      });
    },
    removeBox(renderBox) {
      // delete dynamically
      this.$confirmDialog.show({
        title: 'Remove Box',
        text: 'Are you sure you want to <b>remove</b> this box?',
      }, async () => {
        this.mainBoxes = this.mainBoxes.filter((mb) => mb.boxId !== renderBox.id);
        this.freezerData.id = this.freezerData._id;
        this.freezerData.boxNumbers = this.mainBoxes;
        this.isLoading = true;
        try {
          await freezerService.update({ freezer: this.freezerData });
          this.$snackbar.showOk({ text: 'The box has been removed.' });
          // filter renderBoxes
          // fix this part there is a bug in rendering deleted data
          this.$router.go(0);
          // this.filterBoxes();
          // this.renderBoxes = this.filterBoxes();
          // this.filterBoxes();
          // this.boxWithLocation = this.mainBoxes
          //   .filter((ab) => this.boxWithLocation.includes(ab.boxId))
          //   .map((ab) => ab.boxId);
          // resetting the list for selecting available box
          // this.boxWithLocation = this.mainBoxes.map((box) => box.boxId);
        } catch (e) {
          const error = e.response.data;
          this.$snackbar.showBad({
            text: ErrorMessageUtil.transform(error),
          });
        }
        this.isLoading = false;
      });
    },
    setBoxData(boxData) {
      let setBoxLocation = {};

      // SLIDING RACK STORAGE
      if (this.showSlidingRack) {
        setBoxLocation = {
          boxLocation: {
            shelfNo: this.activeLocation.activeShelfNo,
            rackNo: this.activeLocation.activeRackNo,
            slidingRackNo: this.activeLocation.activeSlidingRackNo,
          },
          boxId: boxData._id,
        };
      }

      // BOX COLUMN STORAGE
      if (this.showBoxView) {
        setBoxLocation = {
          boxLocation: {
            shelfNo: this.activeBoxContext.shelf.shelfNo,
            rackNo: this.activeBoxContext.column.columnNo,
            slidingRackNo: this.activeLocation.activeSlidingRackNo || null,
          },
          boxId: boxData._id,
        };
      }

      this.singleBox = setBoxLocation;
    },
    confirmBox() {
      // store here the id and boxLocation
      // focus on mainBoxesOnly
      // save here
      // add warning or notification
      this.freezerData.boxNumbers.push(this.singleBox);
      this.saveBox();
    },
    // to be removed, since mainBoxes should not be the source of truth
    fetchAllBoxes() {
      this.mainBoxes = this.freezerData.boxNumbers;
    },
    handleSelect(item) {
      if (!this.freezerData.boxNumbers.some((box) => box.boxId === item._id)) {
        this.selectedBox = item;
        this.setBoxData(item); // Call your existing method
        this.$nextTick(() => {
          this.$refs.select.blur(); // Close the dropdown
        });
      }
    },
    async filterBoxes() {
      const { activeShelfNo, activeRackNo, activeSlidingRackNo } = this.activeLocation;
      this.renderBoxes = [];

      const matchingBoxes = this.freezerData.boxNumbers.filter((box) => {
        if (!box?.boxLocation) return false;

        const { shelfNo, rackNo, slidingRackNo } = box.boxLocation;

        return (
          shelfNo === activeShelfNo
          && rackNo === activeRackNo
          && Number(slidingRackNo) === Number(activeSlidingRackNo)
        );
      });

      const boxPropsArray = await Promise.all(
        matchingBoxes.map((box) => this.fetchBoxData(box.boxId)),
      );

      this.renderBoxes = boxPropsArray;
    },
    async fetchBoxData(boxId) {
      const getBox = await boxService.getOne({ id: boxId });
      return {
        // add id here
        id: getBox._id,
        name: getBox.name,
        noOfRows: getBox.noOfRows,
        noOfColumn: getBox.noOfColumn,
      };
    },
    onEdit(item) {
      const { _id: id } = item;
      this.$router.push({ name: 'specimen.view', params: { id } });
    },
    returnToShelf() {
      this.showSlidingRack = false;
      this.showBoxView = false;
      this.hideFreezer = true;
    },
    // openShelf(shelfIndex) {
    //   this.currentShelf = this.currentShelf === shelfIndex
    //     ? null : shelfIndex;
    //   // this.currentShelf = shelfIndex;
    // },
    toggleShelf(index) {
      const i = this.openShelves.indexOf(index);

      if (i > -1) {
        this.openShelves.splice(i, 1); // close
      } else {
        this.openShelves.push(index); // open (keep others open)
      }
    },
    openRack(rackIndex) {
      this.currentRack = rackIndex;
    },
    openBox(column, shelf) {
      this.activeBoxContext = {
        shelf,
        column,
      };
      this.activeLocation = {};
      this.hideFreezer = false;
      this.showSlidingRack = false;
      this.showBoxView = true;

      this.filterBoxesInBoxLevel();
    },
    viewColumn(column) {
      this.selectedColumn = column;
      this.columnDialog = true;
    },
    getColumnIcon(type) {
      switch (type) {
        case 'Rack':
          return 'mdi-view-stream';

        case 'Box':
          return 'mdi-package-variant-closed';

        case 'Others':
          return 'mdi-dots-horizontal-circle-outline';

        case 'Empty':
          return 'mdi-close-circle-outline';

        default:
          return 'mdi-fridge-outline';
      }
    },
    async filterBoxesInBoxLevel() {
      const { shelf, column } = this.activeBoxContext;

      this.renderBoxes = [];

      const matchingBoxes = this.freezerData.boxNumbers.filter((box) => {
        if (!box?.boxLocation) return false;

        const { shelfNo, rackNo } = box.boxLocation;

        return (
          shelfNo === shelf.shelfNo
          && rackNo === column.columnNo
        );
      });

      const boxPropsArray = await Promise.all(
        matchingBoxes.map((box) => this.fetchBoxData(box.boxId)),
      );

      this.renderBoxes = boxPropsArray;
    },
    getColumnSize(shelf) {
      const count = shelf.contents?.length || 1;

      if (count >= 4) return 3; // 4 columns
      if (count === 3) return 4; // 3 columns
      if (count === 2) return 6; // 2 columns
      return 12; // 1 column
    },
  },
};
</script>

<style scoped>
  .border-style {
    border: 1px solid rgb(180, 178, 178);
    border-radius:5px;
    margin:5px;
  }
  .rack {
    background-color: rgb(255, 255, 255);
  }
  .sliding-rack:hover {
    background-color: rgb(145, 70, 81);
    color:white;
    cursor: pointer;
  }
  .shelves {
    background-color: rgb(247, 241, 241);
    padding:5px;
    margin-bottom:15px;
    height: auto;
  }
  .shelves:hover {
    cursor: pointer;
    background-color: rgb(215, 203, 203);
  }
  .freezerBody {
    background-color:rgb(251, 251, 251);
    padding:10px;
    border:1px solid rgb(180, 178, 178);
    border-radius: 5px;
  }
  .sliding-rack-body {
    background-color:rgb(251, 251, 251);
    padding:10px;
    border:1px solid rgb(180, 178, 178);
    border-radius: 5px;
    height:100%;
  }
  table, tr, th, td {
   border: 1px solid;
  }
  .box-table {
    width:100%;
    /* display: flex; */
    justify-content: center; /* Centers horizontally */
    align-items: center;
  }
  .box-column {
    padding: 2px;
  }
  .box-location {
    padding: 5px;
    background-color: rgb(245, 245, 245);
    border: none;
  }
  .return-btn {
    height:45px !important;
    font-size:15px;
    color:#6e0d1c;
    font-weight:bold;
  }
  .freezer-indicator {
    font-size:15px;
    font-weight:bold;
    color: rgb(50, 48, 48);
    background-color: rgb(245, 245, 245);
  }
  .hover-display-text {
    /* background-color: white; */
    /* color: black; */
    /* padding: 5px; */
  }
  .smpl-details {
    padding: 5px;
  }
  .shelf-window {
    font-weight: bold;
    font-size: 20px;
    color:#6e0d1c;
  }
  .shelf-window:hover {
    font-weight: bold;
    font-size: 20px;
    cursor: pointer;
  }
  .rack-label {
    text-align:center;
    font-weight: bold;
    font-size: 20px;
  }
  .sliding-rack-label {
    text-align:center;
  }
  .display-shelf-label {
    position: absolute;
    font-weight: bold;
    font-size: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* latest */
  .column-card {
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.2s ease;

    height: 100%;      /* ADD THIS */
    min-height: 320px; /* increase baseline */
    display: flex;
    flex-direction: column;
  }

  .column-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.12);
  }

  /* HEADER */
  .column-header {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
  }

  /* BODY */
  .column-body {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  /* EMPTY */
  .column-empty {
    background: #f5f5f5;
    color: #888;
  }

  /* BOX */
  .column-box {
    background: #e3f2fd;
  }

  /* RACK */
  .column-rack {
    background: #fff8e1;
  }

  /* STATES */
  .empty-state, .box-state, .rack-state, .other-state {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* Sliding rack buttons */
  .sliding-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }

  .sliding-btn {
    font-size: 11px;
  }

/* =========================
   PHYSICAL RACK CONTAINER
========================= */

.rack-physical {
  display: flex;
  flex-direction: column;
  height: 320px; /* IMPORTANT: gives rack real physical height */
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #cfcfcf;
  background: linear-gradient(to bottom, #ffffff, #f3f3f3);
  width: 100%;
  margin: 10px;
}

/* =========================
   HEADER (fixed top)
========================= */

.rack-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #fafafa;
  border-bottom: 1px solid #ddd;
}

/* =========================
   RACK BODY (fills remaining space)
========================= */

.rack-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* =========================
   DRAWERS (each sliding rack)
========================= */

.rack-drawer {
  flex: 1; /* THIS is the key → equal height distribution */
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 8px 12px;

  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;

  transition: all 0.2s ease;
  background: white;
}

/* last drawer clean edge */
.rack-drawer:last-child {
  border-bottom: none;
}

/* hover = physical pull effect */
.rack-drawer:hover {
  background: #f1f5f9;
  transform: translateX(4px);
}

/* =========================
   DRAWER CONTENT
========================= */

.drawer-left {
  width: 40px;
  font-weight: bold;
  color: #333;
}

.drawer-center {
  flex: 1;
  font-size: 13px;
  color: #555;
}

.drawer-right {
  width: 20px;
  opacity: 0.5;
}

.rack-physical:hover {
  box-shadow: inset 0 0 10px rgba(0,0,0,0.08);
}

/* OTHERS STATE */
.others-state {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.others-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
}

.dialog-label {
  font-size: 13px;
  font-weight: bold;
  color: #777;
  margin-bottom: 4px;
}

.dialog-value {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  word-break: break-word;
}

</style>
